module.exports = __webpack_public_path__ + "img/894362709.05916b38.jpg";